/** Идентификатор пользователя — как его отдал сервер. */
export type AccountId = string | number;

/** Учётная запись связки браузера (кроме активной): поля — как в контракте `GET Account/Accounts`. */
export interface IBrowserAccount {
    userId: AccountId;
    login: string;
    displayName: string;
    /** Вход протух: переключиться нельзя, нужен вход заново с её логином */
    expired?: boolean;
}

/**
 * Порт связки учётных записей приложения: его реализует `auth.accounts` (`@srm/core/auth`), пакет ядро не
 * импортирует. Отказы — отказы промисов.
 */
export interface IAccountsPort {
    list(): Promise<IBrowserAccount[]>;
    switchTo(userId: AccountId): Promise<void>;
    park(loginHint?: string): Promise<void>;
    remove(userId?: AccountId): Promise<void>;
    parkedFrom(): string | null;
    loginHint(): string | null;
}

/** Отказ связки (`describeAccountsFailure` ядра): без `message` — общий текст с кодом ответа. */
export interface IAccountsFailure {
    code?: string;
    message?: string;
}

export const sameAccount = (left: AccountId | null | undefined, right: AccountId | null | undefined): boolean =>
    left !== null && left !== undefined && right !== null && right !== undefined && String(left) === String(right);
